import { connect } from 'react-redux';
import TabList from './TabList';
import { fetchStock, fetchStockOptions, selectPlantId } from '../../store/actions/stock';
import { userGetPermissions, userGetInfo, userGetInfoClear } from '../../store/actions/user';
import { setSelectTab } from '../../store/actions/tabs';
import { plantVisit } from '../../store/actions/admin';
import { getReportTypes } from '../../store/actions/report';
import { getSettingsPlant } from '../../store/actions/settings';

const mapStateToProps = ({
  reportReducer,
  settingsReducer,
  stockReducer,
  userReducer
}) => ({
  reportReducer,
  settingsReducer,
  stockReducer,
  userReducer
});
const mapDispatchToProps = {
  fetchStock,
  fetchStockOptions,
  getReportTypes,
  getSettingsPlant,
  plantVisit,
  selectPlantId,
  setSelectTab,
  userGetInfo,
  userGetInfoClear,
  userGetPermissions
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TabList);
